import gql from 'graphql-tag';

export default gql(`
mutation DeleteSubscriber($id: ID!) {
  deleteSubscriber(id: $id) {
    id
  }
}`);


// WEBPACK FOOTER //
// ./src/graphql/MutationDeleteSubscriber.js